import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Chrome, LogIn, UserPlus } from "lucide-react";

const inputCls =
  "w-full px-4 py-3.5 rounded-xl border border-slate-200 bg-white text-sm text-slate-800 focus:outline-none focus:ring-2 focus:ring-[#F5B301] placeholder:text-slate-400";

export default function ClienteGate({ onIdentified }) {
  const [modo, setModo] = useState("entrar");
  const [telefone, setTelefone] = useState("");
  const [cpf, setCpf] = useState("");
  const [nome, setNome] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const entrar = async () => {
    if (telefone.replace(/\D/g, "").length < 10) return toast.error("Informe um telefone/WhatsApp válido");
    if (cpf.replace(/\D/g, "").length < 11) return toast.error("Informe um CPF válido");
    setLoading(true);
    try {
      const r = await api.post("/cliente/acesso", { telefone, cpf });
      toast.success(`Bem-vindo(a) de volta, ${r.data.nome}!`);
      onIdentified({ token: r.data.token, nome: r.data.nome, telefone, cpf, email: "" });
    } catch (e) {
      if (e.response?.status === 401) {
        setModo("cadastrar");
        toast.info("Não encontramos seu cadastro — complete seus dados para se cadastrar.");
      } else {
        toast.error(e.response?.data?.detail || "Não foi possível acessar");
      }
    } finally {
      setLoading(false);
    }
  };

  const cadastrar = async () => {
    if (nome.trim().length < 3) return toast.error("Informe seu nome completo");
    if (telefone.replace(/\D/g, "").length < 10) return toast.error("Informe um telefone/WhatsApp válido");
    if (cpf.replace(/\D/g, "").length < 11) return toast.error("Informe um CPF válido");
    setLoading(true);
    try {
      const r = await api.post("/cliente/cadastro", { nome, telefone, cpf, email });
      toast.success("Cadastro realizado! Seus orçamentos ficarão salvos na sua conta.");
      onIdentified({ token: r.data.token, nome: r.data.nome, telefone, cpf, email });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Não foi possível cadastrar");
    } finally {
      setLoading(false);
    }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/orcamento";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="px-4 pt-8 space-y-5" data-testid="cliente-gate">
      <img src="/logo.jpg" alt="Carlos Jr Fretes e Mudanças" className="w-20 h-20 rounded-2xl mx-auto object-contain bg-white p-1 shadow-md" />
      <div className="text-center">
        <h1 className="font-heading text-2xl font-bold text-navy">Identifique-se para continuar</h1>
        <p className="text-sm text-slate-500 mt-1">
          Seus orçamentos ficam salvos na sua conta — consulte, altere e acompanhe quando quiser.
        </p>
      </div>

      {modo === "cadastrar" && (
        <div>
          <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Nome completo *</label>
          <input data-testid="gate-nome-input" className={`${inputCls} mt-1`} placeholder="Seu nome"
            value={nome} onChange={(e) => setNome(e.target.value)} />
        </div>
      )}
      <div>
        <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Telefone / WhatsApp *</label>
        <input data-testid="gate-telefone-input" inputMode="tel" className={`${inputCls} mt-1`} placeholder="(21) 99999-9999"
          value={telefone} onChange={(e) => setTelefone(e.target.value)} />
      </div>
      <div>
        <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">CPF *</label>
        <input data-testid="gate-cpf-input" inputMode="numeric" className={`${inputCls} mt-1`} placeholder="000.000.000-00"
          value={cpf} onChange={(e) => setCpf(e.target.value)} />
      </div>
      {modo === "cadastrar" && (
        <div>
          <label className="text-xs font-semibold text-slate-500 uppercase tracking-wide">E-mail</label>
          <input data-testid="gate-email-input" type="email" className={`${inputCls} mt-1`} placeholder="seu@email.com"
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
      )}

      {modo === "entrar" ? (
        <button data-testid="gate-entrar-btn" onClick={entrar} disabled={loading}
          className="w-full py-4 rounded-2xl bg-navy text-[#F5B301] font-heading font-extrabold text-sm flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-60">
          <LogIn className="w-4 h-4" /> {loading ? "VERIFICANDO..." : "ENTRAR NA MINHA CONTA"}
        </button>
      ) : (
        <button data-testid="gate-cadastrar-btn" onClick={cadastrar} disabled={loading}
          className="w-full py-4 rounded-2xl bg-navy text-[#F5B301] font-heading font-extrabold text-sm flex items-center justify-center gap-2 active:scale-95 transition-transform disabled:opacity-60">
          <UserPlus className="w-4 h-4" /> {loading ? "CADASTRANDO..." : "CADASTRAR E CONTINUAR"}
        </button>
      )}

      {modo === "entrar" ? (
        <button data-testid="gate-modo-cadastro-btn" onClick={() => setModo("cadastrar")}
          className="w-full text-center text-xs text-navy font-semibold underline underline-offset-2">
          Primeira vez? Toque aqui para criar seu cadastro
        </button>
      ) : (
        <button data-testid="gate-modo-login-btn" onClick={() => setModo("entrar")}
          className="w-full text-center text-xs text-navy font-semibold underline underline-offset-2">
          Já tenho cadastro — entrar
        </button>
      )}

      <div className="flex items-center gap-3">
        <div className="flex-1 h-px bg-slate-200" />
        <span className="text-[10px] font-bold text-slate-400 uppercase">ou</span>
        <div className="flex-1 h-px bg-slate-200" />
      </div>
      <button data-testid="gate-google-btn" onClick={google}
        className="w-full py-3.5 rounded-2xl bg-white border-2 border-slate-200 text-navy font-heading font-bold text-xs flex items-center justify-center gap-2 active:scale-95 transition-transform">
        <Chrome className="w-4 h-4" /> ENTRAR COM GOOGLE
      </button>
    </div>
  );
}
